import React, {useEffect} from "react";

export function useFixedHeader() {
    useEffect(() => {
        const $ = window.$;
        $(document.body).removeClass("header-6").addClass("header-7")

    }, []);
}

export function useScrollHeader() {
    useEffect(() => {
        const $ = window.$;
        $(document.body).removeClass("header-7").addClass("header-6")

    }, []);
}

export function useScrollToTop(){
    useEffect(() => {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }, []);
}
